module.exports = __webpack_public_path__ + "static/media/pin-danger-privado.2c29dc08.png";